import { Component,  OnInit } from '@angular/core';

export abstract class AbstractFilterComponent{

  abstract toJson(): any;

}
